"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelEl = void 0;
class labelEl {
    static render(buttonName) {
        const label = document.createElement('label');
        label.htmlFor = buttonName;
        label.innerHTML = `${buttonName.charAt(0).toUpperCase() + buttonName.slice(1)}: `;
        return label;
    }
}
exports.labelEl = labelEl;
